import { Injectable } from '@angular/core';
import { LoadingService, LoadingType } from '@delon/abc';
@Injectable({
    providedIn: 'root',
})
export  class C8DeaultLoading {

    constructor(
        private loadingSrv: LoadingService,
    ) {
    }
      loading(type?: LoadingType){
          if(!type){
            type='spin';
          }     
          this.loadingSrv.open({type});
      }
      loaded(){
        this.loadingSrv.close();
      }
}



